/**
 * This file is autogenerated by a build script, don't change it manually.
 */

export const ICONS = [
    'AccessibilityDottedIcon',
    'ArrowLeftSolidIcon',
    'BellIcon',
    'BikeIcon',
    'BikeSolidIcon',
    'BriefcaseDottedIcon',
    'BroadcastIcon',
    'BusDottedIcon',
    'BusIcon',
    'CalendarDottedIcon',
    'CalendarLightIcon',
    'CalendarPlusIcon',
    'CalendarSolidIcon',
    'CarIcon',
    'CarSolidIcon',
    'ChampagneGlassIcon',
    'CheckDottedIcon',
    'ChecklistDottedIcon',
    'ChecklistLightIcon',
    'CheckmarkLightIcon',
    'CheckmarkSolidIcon',
    'ChevronDownLightIcon',
    'ChevronDownSolidIcon',
    'ChevronLeftLightIcon',
    'ChevronLeftSolidIcon',
    'ChevronRightLightIcon',
    'ChevronRightSolidIcon',
    'ChevronUpLightIcon',
    'ChevronUpSolidIcon',
    'ClipboardIcon',
    'ClockIcon',
    'CloseIcon',
    'CloseSolidIcon',
    'ContractDottedIcon',
    'CreditcardDottedIcon',
    'CrownDottedIcon',
    'CultureSolidIcon',
    'EatDottedIcon',
    'EllipsisDottedIcon',
    'EllipsisLightIcon',
    'EyeIcon',
    'FacebookIcon',
    'FamilySolidIcon',
    'FilterIcon',
    'FireDottedIcon',
    'FoodDottedIcon',
    'GiftCardDottedIcon',
    'GiftCardIcon',
    'GlobeDottedIcon',
    'GoodAdministrationIcon',
    'GroupDottedIcon',
    'HamburgerSolidIcon',
    'HandshakeIcon',
    'InfoDottedIcon',
    'InfoIcon',
    'InstagramIcon',
    'JobsIcon',
    'KeyIcon',
    'LeafDottedIcon',
    'LeafLightIcon',
    'LikeIcon',
    'MerchDottedIcon',
    'MessageDottedIcon',
    'MoneyBillSolidIcon',
    'MusicSolidIcon',
    'NewsletterDottedIcon',
    'OrganizationDottedIcon',
    'ParkRideIcon',
    'ParkRideSolidIcon',
    'PayDottedIcon',
    'PeopleDottedIcon',
    'PeopleLightIcon',
    'PointerDottedIcon',
    'PointerLightIcon',
    'QrcodeIcon',
    'RadioDottedIcon',
    'ReusableCupsIcon',
    'RoutePlannerIcon',
    'SearchLightIcon',
    'SearchSolidIcon',
    'SeatsDottedIcon',
    'SeatsSolidIcon',
    'ShieldCheckSolidIcon',
    'SleepDottedIcon',
    'SocietyIcon',
    'SpectaclesSolidIcon',
    'SportSolidIcon',
    'StarDottedIcon',
    'StarLightIcon',
    'SustainabilityIcon',
    'TaxiIcon',
    'TeleTicketServiceIcon',
    'TermConditionIcon',
    'ThreadsIcon',
    'TicketDottedIcon',
    'TicketFullLineIcon',
    'TiktokIcon',
    'TrainIcon',
    'TrainSolidIcon',
    'TramIcon',
    'TramSolidIcon',
    'UsersDottedIcon',
    'YourekaDottedIcon',
    'YoutubeIcon',
] as const;
